export const DEFAULT_DRIVER_SPEED_MULTIPLIER = 1;

// Converts a speed multiplier (expected range: 0.25–2.0) to a percentage offset from 1.0.
// e.g. 1.2 → +20%, 0.75 → -25%, 1.0 → 0% (default).
export const speedMultiplierToPercentage = (multiplier?: number | null): number => {
  if (multiplier === undefined || multiplier === null) {
    return 0;
  }

  return Math.round((multiplier - DEFAULT_DRIVER_SPEED_MULTIPLIER) * 100);
};

export const speedPercentageToMultiplier = (percentage?: number | null): number => (
  Math.round((DEFAULT_DRIVER_SPEED_MULTIPLIER + (percentage ?? 0) / 100) * 100) / 100
);

export const formatSpeedPercentageLabel = (percentage?: number | null, defaultLabel = 'Default'): string => {
  const speedPercentage = percentage ?? 0;

  if (speedPercentage === 0) {
    return defaultLabel;
  }

  return `${speedPercentage > 0 ? '+' : ''}${speedPercentage}%`;
};
